import "../../../styles/about.css";

import React from "react";

interface SnackbarProps extends React.HTMLAttributes<HTMLDivElement> {}

const Snackbar: React.FC<SnackbarProps> = ({ children, ...rest }) => {
  return (
    <>
      <div className="plush-snackbar" {...rest}>
        {children}
      </div>
      <style jsx>{`
        .plush-snackbar {
          position: fixed;
          display: flex;
          max-width: 90%;
          align-items: center;
          padding: 16px;
          bottom: 56px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9999999;
          background: #191919;
          color: #fff;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px; /* 150% */
          text-wrap: nowrap;
        }
        @media (max-width: 768px) {
          .plush-snackbar {
            width: 90%;
            bottom: 23px;
          }
        }
      `}</style>
    </>
  );
};

export default Snackbar;
